// Adapta linhas do formato novo (ghl_reunioes / ghl_vendas) para o shape que as
// telas do desk (Registro de Eventos) já esperam. GHL é o único formato de
// agendamento/venda; o desk é leitor. SDR/closer são resolvidos por ghl_user_id
// via ghl_pessoa_alias (mapa passado pelo chamador).

function datePart(s) {
  return s ? String(s).slice(0, 10) : '';
}

// nomePorUser: Map(ghl_user_id -> pessoa_nome), de ghl_pessoa_alias
export function adaptReuniaoParaAgendamento(r, nomePorUser) {
  const agendador = r.sdr_nome || (r.sdr_ghl_user_id ? (nomePorUser.get(r.sdr_ghl_user_id) || '') : '');
  return {
    id: r.id,
    created_at: r.created_at,
    data_agendamento: datePart(r.agendada_em) || datePart(r.agendado_em_evento),
    data_reuniao: datePart(r.data_reuniao),
    agendador,
    nome: r.contato_nome || '',
    telefone: r.telefone_canonico || '',
    email: '',
    tipo_agendamento: r.tipo_agendamento || '',
    fonte: r.fonte || '',
    campos_pendentes: r.campos_pendentes === true,
    ghl_opportunity_id: r.ghl_opportunity_id || null,
    evento_origem_id: r.evento_origem_id || null,
  };
}

// status ghl -> chip existente do Registro de Eventos (pending/approved/rejected)
function statusChip(s) {
  if (s === 'realizada') return 'approved';
  if (s === 'pendente_campos') return 'pending';
  if (s === 'perdida') return 'rejected';
  return s || 'pending';
}

export function adaptVenda(v, nomePorUser) {
  const vendedor = v.closer_ghl_user_id ? (nomePorUser.get(v.closer_ghl_user_id) || '') : '';
  const pre_vendedor = v.sdr_ghl_user_id ? (nomePorUser.get(v.sdr_ghl_user_id) || '') : '';
  return {
    id: v.id ?? v.ghl_opportunity_id,
    created_at: v.created_at,
    data_venda: datePart(v.vendido_em),
    nome: v.contato_nome || '',
    telefone: v.telefone_canonico || '',
    email: '',
    vendedor,
    pre_vendedor,
    produto: v.produto || '',
    valor_total: v.valor_venda ?? 0,
    forma_pagamento: v.forma_pagamento || '',
    parcelas: v.parcelas || '', // detalhe financeiro vem do bd (join no pop-up)
    status: statusChip(v.status),
    ghl_opportunity_id: v.ghl_opportunity_id || null,
    evento_origem_id: v.evento_origem_id || null,
  };
}
